import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'scMsisdn',
})
export class MsisdnPipe implements PipeTransform {
  private readonly PREFIX = '316';
  private readonly PREFIX_DATA_ONLY = '319';
  private readonly LENGTH = 11;
  private readonly LENGTH_DATA_ONLY = 13;

  transform(msisdn: string | null | undefined, subText: string = 'shared.inactive'): string {
    if (typeof msisdn !== 'string' || msisdn.trim().length === 0) {
      return subText;
    }

    const isCorrect =
      (msisdn.startsWith(this.PREFIX) || msisdn.startsWith(this.PREFIX_DATA_ONLY)) &&
      (msisdn.length === this.LENGTH || msisdn.length === this.LENGTH_DATA_ONLY);

    return isCorrect ? msisdn : subText;
  }
}
